export default {
  sentry_dsn: 'https://cec028fbd83346df8ed762cf1757251a@sentry.delfi.net/89',
  customer_data_api: 'https://api.delfi.lt/customer-data/v2',
  login_api_client_url: {
    default: 'https://lt-production-login-api-client.s3.delfi.lt/lt.js',
    test: 'https://lt-production-login-api-client.s3.delfi.lt/test.js',
  },
};
